module.exports = __webpack_public_path__ + "static/media/nt-2.7b809c26.png";